import { useEffect, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { useOnboardingStore } from '../../stores/useOnboardingStore';
import styles from './CelebrationModal.module.css';

const CONFETTI_COLORS = ['#45348e', '#937cf4', '#b554cc', '#ff6b6b', '#ffd93d', '#6bcb77', '#4d96ff', '#ff922b'];

const ConfettiPiece = ({ index }: { index: number }) => {
  const style = useMemo(() => {
    const left = Math.random() * 100;
    const delay = Math.random() * 2;
    const duration = 2 + Math.random() * 2;
    const color = CONFETTI_COLORS[index % CONFETTI_COLORS.length];
    const size = 6 + Math.random() * 8;
    const shapes = ['50%', '0%', '2px'];
    const borderRadius = shapes[index % shapes.length];
    return {
      left: `${left}%`,
      animationDelay: `${delay}s`,
      animationDuration: `${duration}s`,
      backgroundColor: color,
      width: `${size}px`,
      height: `${size}px`,
      borderRadius,
    };
  }, [index]);

  return <div className={styles.confetti} style={style} />;
};

const CelebrationModal = () => {
  const showCelebration = useOnboardingStore((s) => s.showCelebration);
  const dismissCelebration = useOnboardingStore((s) => s.dismissCelebration);

  const isBigCelebration = showCelebration?.type === 'onboarding_completed';

  useEffect(() => {
    if (showCelebration && !isBigCelebration) {
      const timer = setTimeout(dismissCelebration, 3000);
      return () => clearTimeout(timer);
    }
  }, [showCelebration, isBigCelebration, dismissCelebration]);

  if (!showCelebration) return null;

  return (
    <>
      {/* Confetti for all celebrations */}
      {createPortal(
        <div className={styles.confettiContainer}>
          {Array.from({ length: isBigCelebration ? 60 : 30 }, (_, i) => (
            <ConfettiPiece key={i} index={i} />
          ))}
        </div>,
        document.body,
      )}

      <div className={styles.overlay} onClick={isBigCelebration ? undefined : dismissCelebration}>
        <div
          className={`${styles.modal} ${isBigCelebration ? styles.modalBig : ''}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className={styles.icon}>
            {isBigCelebration ? '🎉' : '✅'}
          </div>
          <h3 className={styles.title}>{showCelebration.message}</h3>
          <p className={styles.message}>
            {isBigCelebration
              ? '¡Tu negocio está listo para operar! Ahora puedes explorar todas las funcionalidades de Prikly.'
              : 'Sigue así, estás configurando tu negocio como un pro.'}
          </p>
          <button className={styles.btn} onClick={dismissCelebration}>
            {isBigCelebration ? '¡Empezar a usar Prikly!' : 'Continuar'}
          </button>
        </div>
      </div>
    </>
  );
};

export default CelebrationModal;
